// extracted by mini-css-extract-plugin
module.exports = {"error":"styles_error__3s8Sj","img":"styles_img__1mEAq","content":"styles_content__2rvKY"};